import React, { useState, useEffect } from "react";
import Dropdown from "components/dropdown";
import { BrowserRouter as Router, Switch, Route, Link } from 'react-router-dom';
import { FiAlignJustify } from "react-icons/fi";
import { FiSearch } from "react-icons/fi";
import { RiMoonFill, RiSunFill } from "react-icons/ri";
//import axios from 'axios';
import axios from "../../api/axios";

import AdminNotifications from "views/admin/raport/components/AdminNotifications";
import PoliceNotifications from "views/admin/raport/components/PoliceNotifications";

const Navbar = ({ onOpenSidenav, brandText, notifications, setNotifications }) => {
  const [darkmode, setDarkmode] = React.useState(false);
  const [userRole, setUserRole] = useState(null);
  const obj = {
    model: {
      name: '',
      pictureUrl: '',
    },
    picture: ''
  }
  const [data, setData] = useState(obj);

useEffect(() => {
  const fetchData = async () => {
    const storedToken = localStorage.getItem("token"); 
    const userId = localStorage.getItem("userId");
    if (!storedToken || !userId) return;

    const token = "Bearer " + storedToken.replace(/"/g, '');
    const headers = { Authorization: token, "Content-Type": "application/json" };

    try {
      // const response = await axios.get(
      //   `http://192.168.5.60:5000/api/account/getadministrator?userId=${userId}`,
      //   { headers }
      // );
        const response = await axios.get(
        `https://api.omnirep.online/api/account/getadministrator?userId=${userId}`,
        { headers }
      );

      setData(response.data);
      // localStorage.setItem("adminName", response.data.model.name);
      setUserRole(response.data.model.role); // <-- add this line to get the role
    } catch (error) {
      console.error(error);
    }
  };

  fetchData();
}, []);


 return (
   <nav className="sticky top-0 z-40 flex flex-row items-center justify-between rounded-xl bg-white/10 p-2 shadow-sm backdrop-blur-xl dark:bg-[#0b14374d]">
     {/* Left: Brand Text */}
     <div className="flex items-center gap-3">
       <span
         className="flex cursor-pointer text-xl text-gray-600 dark:text-white xl:hidden"
         onClick={onOpenSidenav}
       >
         <FiAlignJustify className="h-5 w-5" />
       </span>
       <Link
         to="#"
         className="text-2xl font-bold text-navy-700 hover:text-navy-700 dark:text-white dark:hover:text-white"
       >
         {brandText}
       </Link>
     </div>

     {/* Right: Notifications + Profile Dropdown */}
     <div className="flex items-center gap-5">
       {userRole === "admin" || userRole === "admin assistant" ? (
         <AdminNotifications
           notifications={notifications}
           setNotifications={setNotifications}
         />
       ) : (
         <PoliceNotifications />
       )}

       <Dropdown
         button={
           <img
             className="h-10 w-[4.5rem] rounded-full"
             src={data.picture}
             alt=""
           />
         }
         children={
           <div className="flex h-48 w-56 flex-col justify-start rounded-[20px] bg-white shadow-xl dark:!bg-navy-700 dark:text-white">
             <div className="ml-4 mt-3">
               <p className="text-sm font-bold text-navy-700 dark:text-white">
                 👋 {data.model.name}
               </p>
             </div>
             <div className="mt-3 h-px w-full bg-gray-200 dark:bg-white/20" />
             <div className="ml-4 mt-3 flex flex-col">
               <Link
                 to="profile"
                 className="text-sm text-gray-800 dark:text-white hover:dark:text-white"
               >
                 Profili
               </Link>
               <Link
                 to="edit-profile"
                 className="mt-3 text-sm text-gray-800 dark:text-white hover:dark:text-white"
               >
                 Ndrysho të dhënat personale
               </Link>
               <Link
                 to="edit-pass"
                 className="mt-3 text-sm text-gray-800 dark:text-white hover:dark:text-white"
               >
                 Ndrysho fjalëkalimin
               </Link>
               <Link
                 onClick={() => {
                   localStorage.removeItem("token");
                   localStorage.removeItem("userId");
                 }}
                 to="../auth/sign-in"
                 className="mt-3 text-sm font-medium text-red-500 hover:text-red-500"
               >
                 Çkyçu
               </Link>
             </div>
           </div>
         }
         classNames="py-2 top-8 -left-[180px] w-max"
       />
     </div>
   </nav>
 );
};


export default Navbar;
